import { render, staticRenderFns } from "./IndexCitas.vue?vue&type=template&id=6ba28b42&"
import script from "./IndexCitas.vue?vue&type=script&lang=js&"
export * from "./IndexCitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports